<template>
    <div class="cloud-no-video">
        <div class="no-video-content">
            <h2>{{$t('cloud.noVideo')}}</h2>
            <p>
                <a v-if="!FEATURE('main.how_to_bind')" class="ui-button empty-button short-button" :href="config.support_url" target="_blank">{{ $t('cloud.reolinkCloudLink') }} <span class="icon-icon_arrow-right" style="font-size: 0.1rem;"></span></a>
            </p>
            <a class="text-link" :href="config.officialStore" target="_blank" v-if="!FEATURE('main.shop')">{{$t('cloud.shopButton')}}</a>
            <span class="text-link" target="_blank" v-if="renewal" @click="gotoRenewal">{{$t('cloud.renewal')}}</span>
        </div>
    </div>
</template>

<script>
import { config } from 'CONFIG';
export default {

    data () {

        return {

            config

        };

    },
    props: {
        renewal: Boolean
    },
    methods: {

        gotoRenewal () {

            this.$router.push( '/user/subscribe-plan/' );

        }

    }

};
</script>

<style scoped>
    .cloud-no-video{
        background-image: url('~IMAGE/cloud/no-video.png');
        height: 5.5rem;
        background-position: center;
        position: relative;
        background-repeat: no-repeat;
    }
    .no-video-content{
        text-align: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
    }
    .no-video-content>h2{
        font-size: 0.4rem;
        font-weight: 500;
        margin-bottom: 0.4rem;
        color: #2B2B2B;
    }
    .no-video-content>p{
        font-size: 0.18rem;
        margin-bottom: 0.2rem;
    }
    .no-video-content>a:hover{
        text-decoration: underline;
    }
    .text-link{
        font-size: 0.16rem;
    }
    .text-link span {
        margin-left: 0.8rem;
    }
    @media screen and (max-width:1199px) {
        .cloud-no-video{
            background-image: url('~IMAGE/cloud/no-video-m.png');
            background-position: center bottom;
            padding-bottom: 4rem;
            height: 3.5rem;
            background-size: contain;
        }
        .no-video-content{
            position: static;
            transform: none;
            padding-top: 1.5rem;
        }
        .text-link{
            font-size: 0.24rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/cloud/Novideo.vue